import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function PageShell({ children, testid }) {
    return (
        <div className="relative min-h-screen bg-page text-ink overflow-hidden" data-testid={testid || "page-shell"}>
            <Nav />
            <main className="relative">{children}</main>
            <Footer />
        </div>
    );
}
